import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import logger from 'logger';
import { HEIGHT_UNIT } from 'enum/profile';
import ApiService from 'services/ApiService/ApiService';

import { COUNTRIES_URL, EDITPROFILE_URL } from './Api';


const UPDATE_PROFILE = 'cam4/studio/UPDATE_PROFILE';
const UPDATE_PROFILE_FIELD = 'cam4/studio/UPDATE_PROFILE_FIELD';
const UPDATE_COUNTRIES = 'cam4/studio/UPDATE_COUNTRIES';

export const NAME = 'editProfileDetails';

const initialState = Immutable.fromJS({
  profileInfo: {},
  countries: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PROFILE:
      for (const key in action.profileInfo) {
        if (!Object.hasOwn(action.profileInfo, key)) {
          continue;
        }

        if (key !== 'height' || action.profileInfo.height === null) {
          state = state.setIn(['profileInfo', key], action.profileInfo[key] ? action.profileInfo[key] : null);

          continue;
        }

        state = state.setIn(['profileInfo', 'height'], action.profileInfo.height);

        if (action.profileInfo.heightUnit !== HEIGHT_UNIT.IMPERIAL) {
          continue;
        }

        if (action.profileInfo.height !== '0,0') {
          const result = action.profileInfo.height.split(',');
          state = state.setIn(['profileInfo', 'heightFeet'], result[0]);
          state = state.setIn(['profileInfo', 'heightInches'], result[1]);
        }
      }

      return state;

    case UPDATE_PROFILE_FIELD:
      if (action.label === 'height') {
        state = state.setIn(['profileInfo', 'height'], action.value);
        if (state.getIn(['profileInfo', 'heightUnit']) === HEIGHT_UNIT.IMPERIAL) {
          const result = action.value.split(',');
          state = state.setIn(['profileInfo', 'heightFeet'], result[0]);
          state = state.setIn(['profileInfo', 'heightInches'], result[1]);
        }
      } else {
        state = state.setIn(['profileInfo', action.label], action.value);
      }

      return state;

    case UPDATE_COUNTRIES:
      return state.set('countries', action.countries);

    default:
      return state;
  }
}

function updateProfileDetails(profileInfo) {
  return {
    type: UPDATE_PROFILE,
    profileInfo,
  };
}

function updateProfileLabel(label, value) {
  return {
    type: UPDATE_PROFILE_FIELD,
    label,
    value,
  };
}

function getProfileInfo(userName) {
  const URL = ApiService.substitute(EDITPROFILE_URL, { userName });

  return (dispatch) => ApiService.get(URL)
    .then((res) => dispatch(updateProfileDetails(res.data)));
}

function updateProfileInfo(userName, data, callback) {
  Object.keys(data).forEach((key) => {
    if (key === 'heightFeet') {
      delete data.heightFeet;
    }

    if (key === 'heightInches') {
      delete data.heightInches;
    }

    if (key !== 'city' && (!data[key] || (typeof data[key] === typeof [] && !data[key].length))) {
      delete data[key];
    }
  });

  const URL = ApiService.substitute(EDITPROFILE_URL, { userName });

  return (dispatch) =>
    ApiService.post(URL, {
      data,
      headers: { 'content-type': 'application/json; charset=utf-8' },
    }).then(() => {
      callback(true);

      return dispatch(getProfileInfo(userName));
    }).catch((error) => {
      callback(false);
      logger.warn(error);
    });
}

function updateCountries(countries) {
  return {
    type: UPDATE_COUNTRIES,
    countries,
  };
}

function getCountries(username) {
  const URL = COUNTRIES_URL.replace('{username}', username);

  return (dispatch) =>
    ApiService.get(URL)
      .then((results) => {
        dispatch(updateCountries(results.data.countries));
      })
      .catch((error) => {
        logger.warn(error);
      });
}

const profileInfo = (state) => state[NAME].get('profileInfo');
const countries = (state) => state[NAME].get('countries');

export const actionCreators = {
  getProfileInfo,
  getCountries,
  updateProfileLabel,
  updateProfileInfo,
};

export const selector = createStructuredSelector({
  profileInfo,
  countries,
});
